var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "memberinvoiceinsight-page page-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "memberinvoice_headercontainer d-flex align-items-end justify-content-between flex-wrap gap-2"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _vm._m(0)], 1)]), _c('div', {
    staticClass: "row mt-4 mb-4"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6"
  }, [_c('div', {
    staticClass: "memberinsight_summarycard"
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Unpaid Invoice")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.totalPremium || '$0.00'))])]), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "-2 -3 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "m12.8 1.613l6.701 11.161c.963 1.603.49 3.712-1.057 4.71a3.2 3.2 0 0 1-1.743.516H3.298C1.477 18 0 16.47 0 14.581c0-.639.173-1.264.498-1.807L7.2 1.613C8.162.01 10.196-.481 11.743.517c.428.276.79.651 1.057 1.096m-2.22.839a1.077 1.077 0 0 0-1.514.365L2.365 13.98a1.17 1.17 0 0 0-.166.602c0 .63.492 1.14 1.1 1.14H16.7c.206 0 .407-.06.581-.172a1.164 1.164 0 0 0 .353-1.57L10.933 2.817a1.1 1.1 0 0 0-.352-.365zM10 14a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1"
    }
  })])])])]), _c('div', {
    staticClass: "invoicetotal"
  }, [_vm._v(_vm._s(_vm.paginationMeta.total || 0) + " invoices · Not in commission")])])])]), _c('div', {
    staticClass: "row memberinvoiceinsight-card"
  }, [_c('div', {
    staticClass: "memberinvoiceinsight-filters"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search,
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search Rep Name"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M18 10c0-4.41-3.59-8-8-8s-8 3.59-8 8s3.59 8 8 8c1.85 0 3.54-.63 4.9-1.69l5.1 5.1L21.41 20l-5.1-5.1A8 8 0 0 0 18 10M4 10c0-3.31 2.69-6 6-6s6 2.69 6 6s-2.69 6-6 6s-6-2.69-6-6"
    }
  })])])]), _c('QuickDropdownFilter', {
    attrs: {
      "label": "Date",
      "options": _vm.dateOptions,
      "modelValue": _vm.datefilterType
    },
    on: {
      "update:modelValue": function updateModelValue($event) {
        _vm.datefilterType = $event;
      }
    }
  }), _c('button', {
    staticClass: "clear-btn d-flex align-items-center gap-1",
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('span', {
    staticClass: "icon-wrap d-flex align-items-center justify-content-center"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z"
    }
  })])]), _vm._v(" Clear ")])], 1), _c('div', {
    staticClass: "top-pagination p-0"
  }, [_c('IhaPagination', {
    attrs: {
      "rows": _vm.paginationMeta
    },
    on: {
      "page-change": _vm.handlePageChange
    }
  })], 1), _c('div', {
    staticClass: "table-responsive p-0"
  }, [_c('table', {
    staticClass: "table planswitchhistory-table"
  }, [_vm._m(1), _c('tbody', [_vm.loading ? _vm._l(_vm.perPage, function (n) {
    return _c('tr', {
      key: 'skel-' + n,
      staticClass: "skeleton-row"
    }, [_vm._m(2, true), _vm._m(3, true), _vm._m(4, true), _vm._m(5, true), _vm._m(6, true), _vm._m(7, true), _vm._m(8, true), _vm._m(9, true), _vm._m(10, true), _vm._m(11, true)]);
  }) : _vm._l(_vm.invoices, function (item) {
    return _c('tr', {
      key: item.systemId
    }, [_c('td', [_vm._v(_vm._s(item.systemId))]), _c('td', [_vm._v(_vm._s(item.effectiveDate))]), _c('td', [_c('div', {
      staticClass: "fw-semibold"
    }, [_vm._v(_vm._s(item.invoiceMonth))]), _c('div', {
      staticClass: "txt-small"
    }, [_vm._v("Bill date: " + _vm._s(item.billDate))])]), _c('td', [_c('div', {
      staticClass: "fw-semibold"
    }, [_vm._v(_vm._s(item.member))]), _c('div', {
      staticClass: "txt-small"
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "16",
        "height": "16",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"
      }
    })])]), _vm._v(" " + _vm._s(item.email))]), _c('div', {
      staticClass: "txt-small"
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "16",
        "height": "16",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "m16.1 13.359l-.528-.532zm.456-.453l.529.532zm2.417-.317l-.358.66zm1.91 1.039l-.358.659zm.539 3.255l.529.532zm-1.42 1.412l-.53-.531zm-1.326.67l.07.747zm-9.86-4.238l.528-.532zM4.002 5.746l-.749.042zm6.474 1.451l.53.532zm.157-2.654l.6-.449zM9.374 2.86l-.601.45zM6.26 2.575l.53.532zm-1.57 1.56l-.528-.531zm7.372 7.362l.529-.532zm4.567 2.394l.455-.453l-1.058-1.064l-.455.453zm1.985-.643l1.91 1.039l.716-1.318l-1.91-1.038zm2.278 3.103l-1.42 1.413l1.057 1.063l1.42-1.412zm-2.286 1.867c-1.45.136-5.201.015-9.263-4.023l-1.057 1.063c4.432 4.407 8.65 4.623 10.459 4.454zm-9.263-4.023c-3.871-3.85-4.512-7.087-4.592-8.492l-1.498.085c.1 1.768.895 5.356 5.033 9.47zm1.376-6.18l.286-.286L9.95 6.666l-.287.285zm.515-3.921L9.974 2.41l-1.201.899l1.26 1.684zM5.733 2.043l-1.57 1.56l1.058 1.064l1.57-1.56zm4.458 5.44c-.53-.532-.53-.532-.53-.53h-.002l-.003.004a1 1 0 0 0-.127.157c-.054.08-.113.185-.163.318a2.1 2.1 0 0 0-.088 1.071c.134.865.73 2.008 2.256 3.526l1.058-1.064c-1.429-1.42-1.769-2.284-1.832-2.692c-.03-.194.001-.29.01-.312q.009-.02 0-.006a.3.3 0 0 1-.03.039l-.01.01l-.01.009zm1.343 4.546c1.527 1.518 2.676 2.11 3.542 2.242c.443.068.8.014 1.071-.087a1.5 1.5 0 0 0 .42-.236l.05-.045l.007-.006l.003-.003l.001-.002s.002-.001-.527-.533c-.53-.532-.528-.533-.528-.533l.002-.002l.002-.002l.006-.005l.01-.01l.038-.03q.014-.009-.007.002c-.025.009-.123.04-.32.01c-.414-.064-1.284-.404-2.712-1.824zm-1.56-9.62C8.954 1.049 6.95.834 5.733 2.044L6.79 3.107c.532-.529 1.476-.475 1.983.202zM4.752 5.704c-.02-.346.139-.708.469-1.036L4.163 3.604c-.537.534-.96 1.29-.909 2.184zm14.72 12.06c-.274.274-.57.428-.865.455l.139 1.494c.735-.069 1.336-.44 1.784-.885zM11.006 7.73c.985-.979 1.058-2.527.229-3.635l-1.201.899c.403.539.343 1.246-.085 1.673zm9.52 6.558c.817.444.944 1.49.367 2.064l1.058 1.064c1.34-1.333.927-3.557-.71-4.446zm-3.441-.849c.384-.382 1.002-.476 1.53-.19l.716-1.317c-1.084-.59-2.428-.427-3.304.443z"
      }
    })])]), _vm._v(_vm._s(item.phone))])]), _c('td', [_vm._v(_vm._s(item.plan))]), _c('td', [_vm._v(_vm._s(item.tier))]), _c('td', [_vm._v(_vm._s(item.rep))]), _c('td', [_c('span', {
      class: ['badges', item.paymentStatus ? item.paymentStatus.toLowerCase().replace(/\s+/g, '-') : 'unpaid']
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "16",
        "height": "16",
        "viewBox": "0 0 24 24"
      }
    }, [_c('g', {
      attrs: {
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M12 6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m0 10a1 1 0 1 0 0 2a1 1 0 0 0 0-2"
      }
    }), _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 0 16 0a8 8 0 0 0-16 0",
        "clip-rule": "evenodd"
      }
    })])])]), _vm._v(" " + _vm._s(item.paymentStatus || 'Unpaid'))])]), _c('td', [_vm._v(_vm._s(item.reason))]), _c('td', {
      staticClass: "fw-semibold"
    }, [_vm._v(_vm._s(item.premium))])]);
  }), !_vm.loading && _vm.invoices.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No invoice data found")])]) : _vm._e()], 2)])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Member Invoice Insights")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("System ID")]), _c('th', [_vm._v("Effective Date")]), _c('th', [_vm._v("Invoice Details")]), _c('th', [_vm._v("Primary Member")]), _c('th', [_vm._v("Plan")]), _c('th', [_vm._v("Tier")]), _c('th', [_vm._v("Rep")]), _c('th', [_vm._v("Payment Status")]), _c('th', [_vm._v("Reason")]), _c('th', [_vm._v("Premium")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "80px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "72px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "110px"
    }
  }), _c('span', {
    staticClass: "skeleton-cell mt-1",
    staticStyle: {
      "width": "90px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "100px"
    }
  }), _c('span', {
    staticClass: "skeleton-cell mt-1",
    staticStyle: {
      "width": "130px"
    }
  }), _c('span', {
    staticClass: "skeleton-cell mt-1",
    staticStyle: {
      "width": "110px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "140px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "30px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "90px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "70px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "110px"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', [_c('span', {
    staticClass: "skeleton-cell",
    staticStyle: {
      "width": "55px"
    }
  })]);
}]

export { render, staticRenderFns }